// extracted by mini-css-extract-plugin
export default {"leftIconWrapper":"assessment_checkmarks-module___leftIconWrapper___cc91a643","leftIconsContainer":"assessment_checkmarks-module___leftIconsContainer___d7bfe072"};